<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import CommentForm from "@/comments/CommentForm.vue";
import CommentItem from "@/comments/CommentItem.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import type { MutationStatus } from "@tanstack/vue-query";
import type { Comment, NewComment } from "./types";

defineProps<{
  comments: Array<Comment> | undefined;
  creatingStatus: MutationStatus;
  deletingStatus: MutationStatus;
  creatingError: Error | null;
}>();

defineEmits<{
  create: [comment: NewComment];
  update: [comment: Comment];
  initiateDelete: [];
  delete: [comment: Comment];
}>();

const { me, getMeStatus } = useGetMe();
</script>

<template>
  <div class="box column column-xl container container-md">
    <CommentForm
      :creating-status="creatingStatus"
      :error="creatingError"
      @submit="(comment: NewComment) => $emit('create', comment)"
    />
    <HandleQueryStatus :query-status="getMeStatus">
      <div class="column column-lg">
        <CommentItem
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
          :me="me"
          :deleting-status="deletingStatus"
          @initiate-delete="$emit('initiateDelete')"
          @delete="(comment: Comment) => $emit('delete', comment)"
          @update="(comment: Comment) => $emit('update', comment)"
        />
      </div>
    </HandleQueryStatus>
  </div>
</template>
